import { ReactElement } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import type { GuidanceType } from '../ComparisonTabs'
import type { ApprovalValues, BaseAndRequestedValue, GuidanceValues } from './createDataPointsValue'
import DataPointsCell from './DataPointsCell'

export type RowDataPoints = {
  baseline?: number | null
  ogmOrMargin?: number | null
  requestedValue?: number | null
  guidanceValues?: GuidanceValues
  approvalValues?: ApprovalValues
}

export const createDataPointsCellRenderer =
  <T,>(
    rowMapper: (row: T) => RowDataPoints,
    showRequestedPrice: boolean,
    selectedApprovalTypes?: string[],
    selectedGuidanceTypes?: GuidanceType[],
    colorMap?: BaseAndRequestedValue['colorMap']
  ) =>
  (params: ICellRendererParams<T>): ReactElement | null => {
    if (!params.data || params.node?.rowPinned) return null

    const mapped = rowMapper(params.data)

    return (
      <DataPointsCell
        {...mapped}
        isRequestedPriceActive={showRequestedPrice}
        selectedApprovalTypes={selectedApprovalTypes}
        selectedGuidanceTypes={selectedGuidanceTypes}
        colorMap={colorMap}
      />
    )
  }
